/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setRequirePasscodeConfirmation} from '../api'

export const useMutationSetRequirePasscodeConfirmation = createReactQueryMutationHook('setRequirePasscodeConfirmation', setRequirePasscodeConfirmation)
